module.exports = __webpack_public_path__ + "static/media/equalicare-cover.25145bcf.png";